import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type ContactTag } from "@/lib/types";
import { baseContactRoute } from "./contact";

export const retrieveContactTagsV1 = () => {
  return authenticatedFastApiAxiosInstance
    .get<APIResponse<ContactTag[]>>(`${baseContactRoute}/tags`)
    .then((res) => res.data);
};

export const createContactTagV1 = (data: Partial<ContactTag>) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<ContactTag>>(`${baseContactRoute}/tags`, data)
    .then((res) => res.data);
};

export const updateContactTagV1 = (
  data: Pick<ContactTag, "id" | "dateModified"> & Partial<ContactTag>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<ContactTag>>(`${baseContactRoute}/tags`, data)
    .then((res) => res.data);
};

export const deleteContactTagV1 = (data: { id: string }) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<ContactTag>>(`${baseContactRoute}/tags/${id}`)
    .then((res) => res.data);
};
